<template>
  <div>
    <ion-badge 
      v-for="device in data.devices" 
      :key="device.serialNumber"
      class="ion-margin-end"
    >
      {{ device.serialNumber }}
    </ion-badge>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  data() {
    return {
      data: {},
    }
  }
}
</script>

<style scoped>
div {
  white-space: normal;
}
</style>